function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-318.000000, -381.000000)"
}, React.createElement("g", {
  transform: "translate(113.000000, 355.000000)"
}, React.createElement("g", {
  transform: "translate(205.000000, 26.000000)"
}, React.createElement("g", null, React.createElement("path", {
  id: "Path",
  d: "M10.8,0c0.5,0.2,0.6,0.5,0.6,1c0,1.4,0,2.9,0,4.3c0,0.2,0,0.2,0.2,0.2c0.8,0,1.7,0,2.5,0.1 c1.9,0.1,3.7,0.4,5.5,1c1.5,0.5,2.9,1.2,4.1,2.2c1.2,1.1,2.1,2.4,2.6,3.9c0.3,0.9,0.5,1.8,0.6,2.7c0.1,0.7,0.1,1.4,0,2.1 c-0.1,1.2-0.2,2.4-0.5,3.6c-0.2,0.9-0.4,1.8-0.7,2.7c0,0,0,0.1-0.1,0.1c0,0,0-0.1,0-0.1c0.1-1.6,0.1-3.2-0.2-4.7 c-0.3-1.4-0.8-2.8-1.8-3.9c-0.8-0.9-1.8-1.6-2.9-2.1c-1.2-0.5-2.5-0.9-3.8-1.1c-1-0.2-2-0.3-3-0.3c-0.8,0-1.6-0.1-2.4-0.1 c-0.1,0-0.2,0-0.2,0.2c0,1.5,0,2.9,0,4.4c0,0.5-0.3,0.8-0.8,0.9c-0.2,0-0.4-0.1-0.6-0.2c-2.4-1.9-4.8-3.8-7.2-5.6 c-0.9-0.7-1.7-1.4-2.6-2c-0.4-0.3-0.4-1,0-1.3C3.5,5.4,6.8,2.8,10,0.3c0.1-0.1,0.3-0.2,0.5-0.3C10.6,0,10.7,0,10.8,0z"
}))))));

var SvgUndo = function SvgUndo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 24",
    style: {
      enableBackground: "new 0 0 27 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Undo.3ad4aa09.svg";
export { ForwardRef as ReactComponent };